module.exports = __webpack_public_path__ + "static/Hero-5193dcef4b059f630c1dcd729b15b305.jpg";